module.exports = __webpack_public_path__ + "static/entertainer-b45aa0d141aab8464fbc6e49b2af9411.webp";